/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType } from "igniteui-react-core";
import { ICellPresenter_$type } from "./ICellPresenter";
import { CellModel } from "./CellModel";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasCellPresenterBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CanvasCellPresenterBase, _super);
    function CanvasCellPresenterBase(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    CanvasCellPresenterBase.prototype.modelUpdated = function (a) {
        this.b(a);
    };
    CanvasCellPresenterBase.prototype.b = function (a) {
        this.a.ca(a.c);
        if (a.a3(CellModel.eb) || a.a3(CellModel.ef) || a.a3(CellModel.ed) || a.a3(CellModel.d9)) {
            this.a.ci(a.ea, a.ee, a.ec, a.d8);
        }
        if (a.aw) {
            this.a.cc(a.k1, a.dy, a.d3, a.d1, a.dw);
        }
        if (a.bj) {
            this.a.cf(a.fc);
            this.a.cp(a.gu);
        }
        if (a.ay) {
            if (a.bd && !this.a.v) {
                this.a.b0();
            }
            if (a.a3(CellModel.dv)) {
                this.a.cb(a.k0.color);
            }
            if (a.a3(CellModel.d7)) {
                this.a.ch(a.b9);
            }
        }
        if (a.bj && a.bd) {
            this.a.cs(a);
        }
    };
    CanvasCellPresenterBase.prototype.c = function (a, b, c) {
        if (c == 0) {
            return a.color;
        }
        if (c == 1) {
            return b.color;
        }
        var d = BrushUtil.k(a, c, b, 0);
        return d.color;
    };
    Object.defineProperty(CanvasCellPresenterBase.prototype, "nativeCell", {
        get: function () {
            return this.a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasCellPresenterBase.prototype, "isCanvasBased", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CanvasCellPresenterBase.$t = markType(CanvasCellPresenterBase, 'CanvasCellPresenterBase', Base.$, [ICellPresenter_$type]);
    return CanvasCellPresenterBase;
}(Base));
export { CanvasCellPresenterBase };
//# sourceMappingURL=CanvasCellPresenterBase.js.map
